import React from 'react';
import Slider from 'react-slick';
import {Link} from "react-router-dom";
import "../Styles/CoursesPage.css";

const CourseSlider = ({courses}) => {
    const colors = [
        '#a594ef', '#f3c6de', '#cec4f8', '#7a8ded', '#33FFF5',
        '#f7f8de', 'rgba(213,134,239,0.95)', '#d9b6f4', 'rgba(233,144,236,0.5)', '#FF3380'
    ];

    const getSliderSettings = (courseCount) => ({
        dots: true,
        infinite: courseCount > 4, // Yeterli kurs varsa infinite çalışsın
        speed: 500,
        slidesToShow: Math.min(4, courseCount), // Kurs sayısı 4’ten azsa o kadar göster
        slidesToScroll: 1,
        autoplay: courseCount > 1, // Tek kurs varsa otomatik kaydırma saçma olur
        autoplaySpeed: 3000,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(2, courseCount),
                    slidesToScroll: 1,
                    infinite: courseCount > 2,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false
                }
            }
        ]
    });


    const settings = {
        dots: true, // Slider altında noktaları gösterir
        infinite: true, // Sonsuz döngü sağlar
        speed: 500, // Geçiş süresi (ms)
        slidesToShow: 4, // Aynı anda kaç kart gözüksün
        slidesToScroll: 1, // Her seferinde kaç kart geçsin
        autoplay: true, // Otomatik kaydırma aç
        autoplaySpeed: 3000, // Otomatik kaydırma hızı (ms)
        //aralarına boşluk ekle


        responsive: [
            {
                breakpoint: 1024, // Tablet ve küçük ekranlar için ayar
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768, // Mobil için ayar
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div style={{margin: '50px'}}>
            <div className="section-title" align={"center"}>
                <h2> POPÜLER KURSLAR</h2>
            </div>
            <Slider {...getSliderSettings(courses?.length || 0)}>
                {courses?.map((course, index) => (
                    <div className="course-container" key={course.id}>

                        <div className="course-card"
                             style={{backgroundColor: colors[index % colors.length]}}>

                            <img src="/images/mamografi_drawing.jpg" alt={course.name}/>

                            <div className="course-details">
                                <small><i className="fa fa-calendar"></i> Start Date:{course.startDate}</small>
                                <small><i className="far fa-clock text-primary"></i> End Date: {course.endDate}
                                </small>
                            </div>

                            <h3>{course.name}</h3>
                            {/*
                            <div className="course-footer">
                                            <span><i
                                                className="fa fa-star text-primary"></i> rating </span>
                                <span>price</span>
                            </div>
                            */}
                            <div className="course-buttons">
                                <Link to={`/course-details/${course.id}`}
                                      className="course-button">Detaylar</Link>

                            </div>
                        </div>

                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default CourseSlider;
